/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell numbers in words`)
};

const es_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deletrea números en palabras`)
};

const de_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen in Worten ausschreiben`)
};

const nl_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrijf getallen in woorden uit`)
};

const fr_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écrivez les nombres en lettres`)
};

const it_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi i numeri in parole`)
};

const pt_br2_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva números em palavras`)
};

const pt_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrever números por extenso`)
};

const ja_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字を単語で表記する`)
};

const zh_nw_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用文字拼写数字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_nav_main_desc", locale)
	if (locale === "en") return en_nw_nav_main_desc(inputs)
	if (locale === "es") return es_nw_nav_main_desc(inputs)
	if (locale === "de") return de_nw_nav_main_desc(inputs)
	if (locale === "nl") return nl_nw_nav_main_desc(inputs)
	if (locale === "fr") return fr_nw_nav_main_desc(inputs)
	if (locale === "it") return it_nw_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_nw_nav_main_desc(inputs)
	if (locale === "pt") return pt_nw_nav_main_desc(inputs)
	if (locale === "ja") return ja_nw_nav_main_desc(inputs)
	return zh_nw_nav_main_desc(inputs)
};